export default __webpack_public_path__ + "static/media/Lira-Bara_ Uganda--08.030239.0ceaf488.JPG";